var exports = {
  "uW": "BadgeInventorySettings.module__section___MTl6aT",
  "Vg": "BadgeInventorySettings.module__grid___MTl6aT",
  "Vs": "BadgeInventorySettings.module__tile___MTl6aT",
  "ay": "BadgeInventorySettings.module__reorderable___MTl6aT",
  "cB": "BadgeInventorySettings.module__dragging___MTl6aT",
  "qS": "BadgeInventorySettings.module__badge___MTl6aT",
  "pq": "BadgeInventorySettings.module__badgeImage___MTl6aT",
  "Vv": "BadgeInventorySettings.module__badgeText___MTl6aT",
  "XD": "BadgeInventorySettings.module__visibility___MTl6aT",
  "UE": "BadgeInventorySettings.module__arrow___MTl6aT",
  "d$": "BadgeInventorySettings.module__arrows___MTl6aT",
  "sM": "BadgeInventorySettings.module__srOnly___MTl6aT",
};

module.exports = exports;
